import { createContext, useContext, useEffect, useState } from 'react';
import API_URL from './config';

const FeaturesContext = createContext({ payslips: false });

export function FeaturesProvider({ children }) {
  const [features, setFeatures] = useState({ payslips: false });

  useEffect(() => {
    fetch(`${API_URL}/features/`)
      .then(res => {
        if (!res.ok) throw new Error('features fetch failed');
        return res.json();
      })
      .then(data => setFeatures(data))
      .catch(() => {
        // Fail-closed: keep default { payslips: false }
      });
  }, []);

  return (
    <FeaturesContext.Provider value={features}>
      {children}
    </FeaturesContext.Provider>
  );
}

export function useFeatures() {
  return useContext(FeaturesContext);
}
